import React, { createContext, useContext, useState } from 'react';
import AchievementCard from '../components/custom_components/AchievementModal';

const AchievementContext = createContext();

export function AchievementProvider({ children }) {
    const [achievementData, setAchievementData] = useState(null);

    const showAchievement = (milestone, data) => {
        setAchievementData({
            milestone,
            data,
            trigger: true
        });
    };

    const hideAchievement = () => {
        setAchievementData(null);
    };

    return (
        <AchievementContext.Provider value={{ showAchievement, hideAchievement }}>
            {children}
            {achievementData && (
                <AchievementCard
                    trigger={achievementData.trigger}
                    milestone={achievementData.milestone}
                    milestoneData={achievementData.data}
                    onClose={hideAchievement}
                />
            )}
        </AchievementContext.Provider>
    );
}

export const useAchievement = () => useContext(AchievementContext);